module.exports = __FOREMAN_VENDOR__CONNECTED_REACT_ROUTER__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__CONNECTED_REACT_ROUTER__"
// module id = connected-react-router
// module chunks = 0